module.exports = __webpack_public_path__ + "static/img/IMG_20150526_143800.c673b062.jpg";